(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-aura-eyes-video-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mejoris-video-gallery')) {
    class MejorisVideoGallery extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('video'));
        this.started = false;

        // Si varios cuadros apuntan al mismo archivo (mismo video
        // reutilizado por falta de clips distintos), distribuye el punto
        // de inicio de cada instancia de forma pareja a lo largo de la
        // duración real del clip (nunca un valor fijo hardcodeado) para
        // que cada cuadro se sienta como un momento distinto — mismo
        // patrón ya validado en video-trio.liquid (Sentinel Lock).
        const groupsBySrc = new Map();
        this.videos.forEach((video) => {
          const source = video.querySelector('source');
          const src = source ? source.getAttribute('src') : '';
          if (!groupsBySrc.has(src)) groupsBySrc.set(src, []);
          groupsBySrc.get(src).push(video);
        });
        groupsBySrc.forEach((group) => {
          if (group.length < 2) return;
          group.forEach((video, index) => {
            const applyOffset = () => {
              if (video.duration && isFinite(video.duration)) {
                video.currentTime = (video.duration * index) / group.length;
              }
            };
            if (video.readyState >= 1) {
              applyOffset();
            } else {
              video.addEventListener('loadedmetadata', applyOffset, { once: true });
            }
          });
        });

        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((e) => e.isIntersecting) && !this.started) {
              this.started = true;
              this.videos.forEach((video) => {
                video.play().catch(() => {});
              });
              this.observer.disconnect();
            }
          },
          { rootMargin: '200px' }
        );
        this.observer.observe(this);
      }
    }
    customElements.define('mejoris-video-gallery', MejorisVideoGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-aura-skin-oferta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mejoris-countdown')) {
    class MejorisCountdown extends HTMLElement {
      connectedCallback() {
        this.totalSeconds = Math.max(60, (parseFloat(this.dataset.minutes) || 30) * 60);
        this.remaining = this.totalSeconds;
        this.h = this.querySelector('[data-cd-h]');
        this.m = this.querySelector('[data-cd-m]');
        this.s = this.querySelector('[data-cd-s]');
        this._render();
        this.interval = setInterval(() => this._tick(), 1000);
      }

      disconnectedCallback() {
        if (this.interval) clearInterval(this.interval);
      }

      _tick() {
        this.remaining -= 1;
        if (this.remaining < 0) this.remaining = this.totalSeconds;
        this._render();
      }

      _render() {
        const pad = (n) => String(n).padStart(2, '0');
        const hh = Math.floor(this.remaining / 3600);
        const mm = Math.floor((this.remaining % 3600) / 60);
        const ss = this.remaining % 60;
        if (this.h) this.h.textContent = pad(hh);
        if (this.m) this.m.textContent = pad(mm);
        if (this.s) this.s.textContent = pad(ss);
      }
    }
    customElements.define('mejoris-countdown', MejorisCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-aura-skin-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mejoris-video-fan')) {
    class MejorisVideoFan extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('.as-fan__card'));
        this.videos = this.cards.map((card) => card.querySelector('video'));
        this.activeIndex = 0;

        this.cards.forEach((card, index) => {
          card.addEventListener('click', () => this._setActive(index));
          card.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              this._setActive(index);
            }
          });
        });

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this._playActive();
              } else {
                this.videos.forEach((video) => video.pause());
              }
            });
          },
          { rootMargin: '150px', threshold: 0.2 }
        );
        this.observer.observe(this);
      }

      _setActive(index) {
        if (index === this.activeIndex || !this.videos[index]) return;
        this.activeIndex = index;
        this._applyRoles();
        this._playActive();
      }

      _playActive() {
        this.videos.forEach((video, index) => {
          if (!video) return;
          if (index === this.activeIndex) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }

      _applyRoles() {
        const total = this.cards.length;
        this.cards.forEach((card, index) => {
          const diff = (index - this.activeIndex + total) % total;
          let role = 'left';
          if (diff === 0) role = 'center';
          else if (diff === 1) role = 'right';
          card.dataset.role = role;
        });
      }
    }
    customElements.define('mejoris-video-fan', MejorisVideoFan);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-aviso-led-carro-multimedia"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mejoris-video-quad')) {
    class MejorisVideoQuad extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('video'));
        this.started = false;

        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((e) => e.isIntersecting) && !this.started) {
              this.started = true;
              this.startAll();
              this.observer.disconnect();
            }
          },
          { rootMargin: '200px' }
        );
        this.observer.observe(this);
      }

      startAll() {
        // Group instances by source video so each source's own instances
        // (2 each) get offsets computed from THAT video's real duration,
        // not a shared/fixed value.
        const groups = {};
        this.videos.forEach((video) => {
          const ref = video.dataset.videoRef;
          (groups[ref] = groups[ref] || []).push(video);
        });
        Object.values(groups).forEach((instances) => {
          instances.forEach((video, index) => this.startInstance(video, index, instances.length));
        });
      }

      startInstance(video, index, total) {
        const seekAndPlay = () => {
          const offset = this.computeOffset(video.duration, index, total);
          if (offset > 0) {
            try {
              video.currentTime = offset;
            } catch (e) {
              /* some browsers throw if not seekable yet; ignored, native loop still works */
            }
          }
          video.play().catch(() => {
            /* autoplay can be rejected before user interaction on some browsers; muted should avoid this */
          });
        };

        if (video.readyState >= 1) {
          seekAndPlay();
        } else {
          video.addEventListener('loadedmetadata', seekAndPlay, { once: true });
        }
      }

      // Distributes `total` instances across a clip's real duration, always
      // leaving a safety margin at both ends (scaled down for short clips)
      // so no instance starts right at the very end. index 0 always starts
      // at 0 (no seek needed); later indices are spread across the rest.
      computeOffset(duration, index, total) {
        if (index === 0 || !duration || !isFinite(duration) || duration <= 0) return 0;

        const edgeGuard = Math.min(0.75, duration * 0.15);
        const usable = Math.max(0, duration - edgeGuard * 2);
        const fraction = index / total;
        let offset = edgeGuard + usable * fraction;

        if (offset >= duration - 0.05) offset = Math.max(0, duration - 0.5);
        return offset;
      }
    }
    customElements.define('mejoris-video-quad', MejorisVideoQuad);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-botiquin-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mejoris-bq-video-gallery')) {
    class MejorisBqVideoGallery extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('video'));
        this.started = new WeakSet();
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.started.has(entry.target)) {
              this.started.add(entry.target);
              entry.target.play().catch(() => {});
            }
          });
        }, { rootMargin: '200px' });
        this.videos.forEach((video) => {
          this.observer.observe(video);
          video.addEventListener('click', () => this._toggleSound(video));
        });
      }
      _toggleSound(video) {
        const unmuting = video.muted;
        video.muted = !unmuting;
        video.controls = unmuting;
        if (unmuting) video.play().catch(() => {});
      }
    }
    customElements.define('mejoris-bq-video-gallery', MejorisBqVideoGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-cero-pinchazos-oferta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mejoris-countdown')) {
    class MejorisCountdown extends HTMLElement {
      connectedCallback() {
        this.totalSeconds = Math.max(60, (parseFloat(this.dataset.minutes) || 30) * 60);
        this.remaining = this.totalSeconds;
        this.h = this.querySelector('[data-cd-h]');
        this.m = this.querySelector('[data-cd-m]');
        this.s = this.querySelector('[data-cd-s]');
        this._render();
        this.interval = setInterval(() => this._tick(), 1000);
      }

      disconnectedCallback() {
        if (this.interval) clearInterval(this.interval);
      }

      _tick() {
        this.remaining -= 1;
        if (this.remaining < 0) this.remaining = this.totalSeconds;
        this._render();
      }

      _render() {
        const pad = (n) => String(n).padStart(2, '0');
        const hh = Math.floor(this.remaining / 3600);
        const mm = Math.floor((this.remaining % 3600) / 60);
        const ss = this.remaining % 60;
        if (this.h) this.h.textContent = pad(hh);
        if (this.m) this.m.textContent = pad(mm);
        if (this.s) this.s.textContent = pad(ss);
      }
    }
    customElements.define('mejoris-countdown', MejorisCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-cero-pinchazos-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mejoris-video-grid')) {
    class MejorisVideoGrid extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('video'));
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting) {
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { rootMargin: '150px', threshold: 0.2 }
        );
        this.videos.forEach((video) => this.observer.observe(video));
      }
    }
    customElements.define('mejoris-video-grid', MejorisVideoGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-chaleco-aromaterapia-video-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mejoris-video-gallery')) {
    class MejorisVideoGallery extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('video'));
        this.started = false;
        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((e) => e.isIntersecting) && !this.started) {
              this.started = true;
              this.videos.forEach((video) => {
                video.play().catch(() => {});
              });
              this.observer.disconnect();
            }
          },
          { rootMargin: '200px' }
        );
        this.observer.observe(this);
      }
    }
    customElements.define('mejoris-video-gallery', MejorisVideoGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-guardian-gps-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGgGallery(gallery) {
      var track = gallery.querySelector('[data-gg-track]');
      var slides = track.children;
      var prevBtn = gallery.querySelector('[data-gg-prev]');
      var nextBtn = gallery.querySelector('[data-gg-next]');
      var thumbsWrap = document.querySelector('[data-gg-thumbs]');
      var thumbs = thumbsWrap ? thumbsWrap.querySelectorAll('[data-gg-thumb-index]') : [];

      function currentIndex() {
        if (!track.clientWidth) return 0;
        return Math.round(track.scrollLeft / track.clientWidth);
      }
      function goTo(index) {
        var max = slides.length - 1;
        if (index < 0) index = 0;
        if (index > max) index = max;
        track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
      }
      function updateActiveThumb() {
        var idx = currentIndex();
        for (var i = 0; i < thumbs.length; i++) {
          thumbs[i].classList.toggle('is-active', i === idx);
        }
      }
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex() - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex() + 1); });
      for (var i = 0; i < thumbs.length; i++) {
        thumbs[i].addEventListener('click', function (e) {
          goTo(parseInt(e.currentTarget.getAttribute('data-gg-thumb-index'), 10));
        });
      }
      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(updateActiveThumb, 80);
      });
    }
    var galleryEl = document.querySelector('[data-gg-gallery]');
    if (galleryEl) initGgGallery(galleryEl);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-guardian-gps-oferta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mejoris-countdown')) {
    class MejorisCountdown extends HTMLElement {
      connectedCallback() {
        this.totalSeconds = Math.max(60, (parseFloat(this.dataset.minutes) || 30) * 60);
        this.remaining = this.totalSeconds;
        this.h = this.querySelector('[data-cd-h]');
        this.m = this.querySelector('[data-cd-m]');
        this.s = this.querySelector('[data-cd-s]');
        this._render();
        this.interval = setInterval(() => this._tick(), 1000);
      }
      disconnectedCallback() { if (this.interval) clearInterval(this.interval); }
      _tick() {
        this.remaining -= 1;
        if (this.remaining < 0) this.remaining = this.totalSeconds;
        this._render();
      }
      _render() {
        const pad = (n) => String(n).padStart(2, '0');
        const hh = Math.floor(this.remaining / 3600);
        const mm = Math.floor((this.remaining % 3600) / 60);
        const ss = this.remaining % 60;
        if (this.h) this.h.textContent = pad(hh);
        if (this.m) this.m.textContent = pad(mm);
        if (this.s) this.s.textContent = pad(ss);
      }
    }
    customElements.define('mejoris-countdown', MejorisCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-guardian-gps-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mejoris-video-fan')) {
    class MejorisVideoFan extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('.gg-fan__card'));
        this.videos = this.cards.map((card) => card.querySelector('video'));
        this.activeIndex = 0;

        this.cards.forEach((card, index) => {
          card.addEventListener('click', () => this._setActive(index));
          card.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              this._setActive(index);
            }
          });
        });

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this._playActive();
              } else {
                this.videos.forEach((video) => video.pause());
              }
            });
          },
          { rootMargin: '150px', threshold: 0.2 }
        );
        this.observer.observe(this);
      }

      _setActive(index) {
        if (index === this.activeIndex || !this.videos[index]) return;
        this.activeIndex = index;
        this._applyRoles();
        this._playActive();
      }

      _playActive() {
        this.videos.forEach((video, index) => {
          if (!video) return;
          if (index === this.activeIndex) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }

      _applyRoles() {
        const total = this.cards.length;
        this.cards.forEach((card, index) => {
          const diff = (index - this.activeIndex + total) % total;
          let role = 'left';
          if (diff === 0) role = 'center';
          else if (diff === 1) role = 'right';
          card.dataset.role = role;
        });
      }
    }
    customElements.define('mejoris-video-fan', MejorisVideoFan);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-kit-emergencia-sismica-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mejoris-kes-video-gallery')) {
    class MejorisKesVideoGallery extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('video'));
        this.started = new WeakSet();
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.started.has(entry.target)) {
              this.started.add(entry.target);
              entry.target.play().catch(() => {});
            }
          });
        }, { rootMargin: '200px' });
        this.videos.forEach((video) => {
          this.observer.observe(video);
          video.addEventListener('click', () => this._toggleSound(video));
        });
      }
      _toggleSound(video) {
        const unmuting = video.muted;
        video.muted = !unmuting;
        video.controls = unmuting;
        if (unmuting) video.play().catch(() => {});
      }
    }
    customElements.define('mejoris-kes-video-gallery', MejorisKesVideoGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-mascara-halloween-luz-led-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mejoris-hml-video-gallery')) {
    class MejorisHmlVideoGallery extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('video'));
        this.started = new WeakSet();
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.started.has(entry.target)) {
              this.started.add(entry.target);
              entry.target.play().catch(() => {});
            }
          });
        }, { rootMargin: '200px' });
        this.videos.forEach((video) => {
          this.observer.observe(video);
          video.addEventListener('click', () => this._toggleSound(video));
        });
      }
      _toggleSound(video) {
        const unmuting = video.muted;
        video.muted = !unmuting;
        video.controls = unmuting;
        if (unmuting) video.play().catch(() => {});
      }
    }
    customElements.define('mejoris-hml-video-gallery', MejorisHmlVideoGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-pestanas-magneticas-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mejoris-pm-carousel')) {
    class MejorisPmCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.autoplayTimer = null;
        this.userInteracted = false;
        if (!this.track) return;

        var self = this;
        function cards() {
          return Array.prototype.slice.call(self.track.querySelectorAll('[data-card]'));
        }
        function currentIndex() {
          var list = cards();
          var trackLeft = self.track.getBoundingClientRect().left;
          var best = 0, bestDist = Infinity;
          list.forEach(function (card, i) {
            var dist = Math.abs(card.getBoundingClientRect().left - trackLeft);
            if (dist < bestDist) { bestDist = dist; best = i; }
          });
          return best;
        }
        function goTo(index) {
          var list = cards();
          if (!list.length) return;
          var clamped = Math.max(0, Math.min(index, list.length - 1));
          list[clamped].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', function () {
            self.stopAutoplay();
            goTo(currentIndex() - 1);
          });
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', function () {
            self.stopAutoplay();
            goTo(currentIndex() + 1);
          });
        }

        ['pointerdown', 'touchstart', 'wheel'].forEach(function (evt) {
          self.track.addEventListener(evt, function () { self.stopAutoplay(); }, { passive: true });
        });

        // Arrastre con mouse (desktop) — el swipe táctil real en móvil ya
        // lo resuelve el navegador de forma nativa vía scroll-snap.
        var isDown = false, startX = 0, startScroll = 0;
        this.track.addEventListener('mousedown', function (e) {
          isDown = true;
          startX = e.pageX;
          startScroll = self.track.scrollLeft;
        });
        window.addEventListener('mouseup', function () { isDown = false; });
        window.addEventListener('mousemove', function (e) {
          if (!isDown) return;
          e.preventDefault();
          self.track.scrollLeft = startScroll - (e.pageX - startX);
        });

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                self.startAutoplay();
              } else {
                self.stopAutoplay(true);
              }
            });
          },
          { threshold: 0.4 }
        );
        this.observer.observe(this);
      }

      startAutoplay() {
        if (this.autoplayTimer || this.userInteracted) return;
        var self = this;
        this.autoplayTimer = setInterval(function () {
          var track = self.track;
          var list = Array.prototype.slice.call(track.querySelectorAll('[data-card]'));
          if (!list.length) return;
          var trackLeft = track.getBoundingClientRect().left;
          var current = 0, bestDist = Infinity;
          list.forEach(function (card, i) {
            var dist = Math.abs(card.getBoundingClientRect().left - trackLeft);
            if (dist < bestDist) { bestDist = dist; current = i; }
          });
          var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 10;
          var next = atEnd ? 0 : Math.min(current + 1, list.length - 1);
          list[next].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }, 3500);
      }

      stopAutoplay(fromViewportExit) {
        if (!fromViewportExit) this.userInteracted = true;
        if (this.autoplayTimer) {
          clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }
    }
    customElements.define('mejoris-pm-carousel', MejorisPmCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-pestanas-magneticas-video-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mejoris-pm-video-gallery')) {
    class MejorisPmVideoGallery extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('video'));
        this.started = new WeakSet();
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !this.started.has(entry.target)) {
                this.started.add(entry.target);
                entry.target.play().catch(() => {});
              }
            });
          },
          { rootMargin: '200px' }
        );
        this.videos.forEach((video) => this.observer.observe(video));
      }
    }
    customElements.define('mejoris-pm-video-gallery', MejorisPmVideoGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-respira-facil-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mejoris-rf-video-gallery')) {
    class MejorisRfVideoGallery extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('video'));
        this.started = false;
        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((e) => e.isIntersecting) && !this.started) {
              this.started = true;
              this.videos.forEach((video) => {
                video.play().catch(() => {});
              });
              this.observer.disconnect();
            }
          },
          { rootMargin: '200px' }
        );
        this.observer.observe(this);
      }
    }
    customElements.define('mejoris-rf-video-gallery', MejorisRfVideoGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-termogrifo-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mejoris-tg-hero-gallery')) {
    class MejorisTgHeroGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-tg-track]');
        this.slides = this.track.children;
        this.prevBtn = this.querySelector('[data-tg-prev]');
        this.nextBtn = this.querySelector('[data-tg-next]');
        this.dots = this.querySelectorAll('[data-tg-dot-index]');
        this.autoplayDelay = 4500;
        this.resumeDelay = 3000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this._goTo(this._currentIndex() - 1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this._goTo(this._currentIndex() + 1));
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this._goTo(parseInt(dot.dataset.tgDotIndex, 10)));
        });

        let scrollTimer;
        this.track.addEventListener('scroll', () => {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(() => this._updateActiveDot(), 80);
        });
        this.track.addEventListener('pointerdown', () => this._pauseAutoplay());

        this.io = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) this._maybeAutoplay();
          else this._pauseAutoplay();
        }, { threshold: 0.3 });
        this.io.observe(this);

        this._maybeAutoplay();
      }

      disconnectedCallback() {
        this._pauseAutoplay();
        if (this.io) this.io.disconnect();
      }

      _currentIndex() {
        if (!this.track.clientWidth) return 0;
        return Math.round(this.track.scrollLeft / this.track.clientWidth);
      }

      _goTo(index) {
        const max = this.slides.length - 1;
        if (index < 0) index = max;
        if (index > max) index = 0;
        this.track.scrollTo({ left: this.track.clientWidth * index, behavior: 'smooth' });
      }

      _updateActiveDot() {
        const idx = this._currentIndex();
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === idx));
      }

      _maybeAutoplay() {
        if (this.reducedMotion || this.autoplayTimer) return;
        this.autoplayTimer = setInterval(() => this._goTo(this._currentIndex() + 1), this.autoplayDelay);
      }

      _pauseAutoplay() {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
        clearTimeout(this.resumeTimer);
        this.resumeTimer = setTimeout(() => this._maybeAutoplay(), this.resumeDelay);
      }
    }
    customElements.define('mejoris-tg-hero-gallery', MejorisTgHeroGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-termogrifo-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mejoris-tg-video-gallery')) {
    class MejorisTgVideoGallery extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('video'));
        this.started = new WeakSet();
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !this.started.has(entry.target)) {
                this.started.add(entry.target);
                entry.target.play().catch(() => {});
              }
            });
          },
          { rootMargin: '200px' }
        );
        this.videos.forEach((video) => {
          this.observer.observe(video);
          video.addEventListener('click', () => this._toggleSound(video));
        });
      }

      _toggleSound(video) {
        const unmuting = video.muted;
        video.muted = !unmuting;
        video.controls = unmuting;
        if (unmuting) video.play().catch(() => {});
      }
    }
    customElements.define('mejoris-tg-video-gallery', MejorisTgVideoGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-trio"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mejoris-video-trio')) {
    class MejorisVideoTrio extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('video'));
        this.started = false;

        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((e) => e.isIntersecting) && !this.started) {
              this.started = true;
              this.videos.forEach((video) => this.startVideo(video));
              this.observer.disconnect();
            }
          },
          { rootMargin: '200px' }
        );
        this.observer.observe(this);
      }

      startVideo(video) {
        const fraction = parseFloat(video.dataset.startFraction || '0');

        const seekAndPlay = () => {
          if (fraction > 0 && video.duration) {
            try {
              video.currentTime = video.duration * fraction;
            } catch (e) {
              /* some browsers throw if not seekable yet; ignored, native loop will still work */
            }
          }
          video.play().catch(() => {
            /* autoplay can be rejected before user interaction on some browsers; muted should avoid this */
          });
        };

        if (video.readyState >= 1) {
          seekAndPlay();
        } else {
          video.addEventListener('loadedmetadata', seekAndPlay, { once: true });
        }
      }
    }
    customElements.define('mejoris-video-trio', MejorisVideoTrio);
  }

  } catch(e) { console.error(e); }
})();
})();
